const PAGES = {
  SEASONS: 'seasons',
  DETAILS: 'details',
};

export default PAGES;
